
const globalCurrentEventId = () => {
    const storedEventId = localStorage.getItem("selectedEventId");
    return storedEventId ? parseInt(storedEventId, 10) : 0;
};

const getCurrencySymbol = (currency: string) => {
    switch (currency?.toLowerCase()) {
        case 'gbp':
            return '£';
        case 'usd':
            return '$';
        case 'eur':
            return '€';
        default:
            return '£'; // Defaulting to GBP if the currency is unrecognized
    }
}

/** Tax % for exhibitor product orders; falls back to booth booking tax. */
const getProductTax = (event: { product_tax?: number | string | null; tax?: number | string | null } | null | undefined): number => {
    if (event?.product_tax != null && event.product_tax !== '') {
        const n = Number(event.product_tax);
        return Number.isNaN(n) ? 0 : n;
    }
    const fallback = Number(event?.tax);
    return Number.isNaN(fallback) ? 0 : fallback;
};

/** Currency code for exhibitor product orders; falls back to booth booking currency. */
const getProductCurrency = (event: { product_currency?: string | null; currency?: string | null } | null | undefined): string => {
    const product = event?.product_currency;
    if (product != null && String(product).trim() !== '') {
        return String(product).trim().toLowerCase();
    }
    const booth = event?.currency;
    return booth ? String(booth).trim().toLowerCase() : 'gbp';
};

export {
    globalCurrentEventId,
    getCurrencySymbol,
    getProductTax,
    getProductCurrency,
}